import { createRecipe } from './runtime';

const tooltipConfig = {"name":"tooltip"}

export const tooltip = /* @__PURE__ */ createRecipe(tooltipConfig)